'use client';

import { CSSProperties, FC, useEffect, useRef } from 'react';

import { scheduleScrollTriggerRefresh } from '@/lib/gsap';
import { BasicProps } from '@/types/common';

interface Props extends BasicProps {
	observerMarginBottom?: number | string;
}

const LazySection: FC<Props> = ({ children, className, observerMarginBottom = 400 }) => {
	const ref = useRef<HTMLDivElement>(null);
	const intrinsicHeight = parseFloat(String(observerMarginBottom)) + 200;

	useEffect(() => {
		const el = ref.current;
		if (!el) return;

		const handleStateChange = (event: Event) => {
			if ((event as any).skipped) return;

			scheduleScrollTriggerRefresh();
		};

		el.addEventListener('contentvisibilityautostatechange', handleStateChange);

		return () => el.removeEventListener('contentvisibilityautostatechange', handleStateChange);
	}, []);

	const style: CSSProperties = {
		display: 'contents',
		contentVisibility: 'auto',
		containIntrinsicSize: `auto ${intrinsicHeight}px`
	};

	return (
		<div ref={ref} className={className} style={style}>
			{children}
		</div>
	);
};

export default LazySection;
